import React, { Children, useEffect } from "react";

export default function CloseOnEscape({ onEscape, children }) {
  const handleEscape = ({ code }) => {
    if (onEscape && code === "Escape") {
      onEscape();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  return <>{Children.only(children)}</>;
}
